import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {Tile, TileId} from '../../../../../../shared/models/tile';
import {TileIcon} from '../../../../../../shared/models/tile-icon';
import {DrawerGapFromTopComponent} from '../../../../drawer-gap-from-top/drawer-gap-from-top.component';
import {TileComponent} from '../../../tile.component';

@Component({
  selector: 'motn-tile-folder-drawer',
  templateUrl: './tile-folder-drawer.component.html',
  styleUrls: ['./tile-folder-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DrawerGapFromTopComponent,
    TileComponent,
  ],
})
export class TileFolderDrawerComponent {
  @Input() childTiles: Tile[];
  @Input() displayName: string;
  @Input() displayIcon: TileIcon;

  @Output() clickedOutside: EventEmitter<null> = new EventEmitter<null>();


  constructor() {
  }
}
